import { useEffect } from "react"
import { useRouteMatch } from 'react-router-dom';

import { useGlobalStore } from "@/stores/global";

export function useBuilderRedirect() {
  const isBuilder = !!useRouteMatch('/cms/:content_type/:post_id/builder')
  const { siteSelected: { id: seletedSiteId } } = useGlobalStore()

  useEffect(() => {
    if (seletedSiteId) {
      const isProduction = process.env.NODE_ENV === 'production'

      if (isProduction && !isBuilder) {
        const url = new URL(window.location.href)
        if (url.hostname.startsWith('next.')) {
          url.hostname = url.hostname.replace(/^next\./, '')
          window.location.replace(url.href)
        }
      }
    } else {
      console.error('seletedSiteId is not set')
    }
  }, [isBuilder, seletedSiteId])
}
